import { type ApiV1 } from '@teamworksdev/influencer/core';
import type { Uuid } from '@/types/utilities';

class Task {
	attachments: ApiV1.Media[];
	completedAt: string | null;
	completedBy: string;
	description: string | null;
	dueAt: string | null;
	isComplete: boolean;
	link: string | null;
	name: string;
	uuid: Uuid;

	constructor(data: ApiV1.Task | ApiV1.TransactionTaskModel) {
		this.attachments = data.attachments ?? [];
		this.completedAt = data.completed_at;
		this.completedBy = data.completed_by ? `${data.completed_by.first_name} ${data.completed_by.last_name}` : '';
		this.description = data.description ?? null;
		this.dueAt = 'due_at' in data
			? data.due_at
			: data.due_date ?? null;
		this.isComplete = data.completed_at !== null;
		this.link = data.link;
		this.name = data.name;
		this.uuid = data.uuid;
	}
}

export {
	Task,
};
